<template>
    <div class="w-full py-4 column_start_start">
        <div class="row_center_start w-full flex-wrap">
            <text class="font-base font-semibold text-[#AAA] mr-3">{{ timeLabel }}</text>
            <text class="font-base mr-3">{{ deliveryDate }}</text> <text v-if="!isRetailPickUp" class="font-base">{{ deliveryTime }}</text>
        </div>
        <div v-if="!isRetailPickUp" class="w-full h-1 border-b border-dashed border-[#AAA] my-4"></div>
        <div v-if="!isRetailPickUp" class="column_start_start w-full flex-wrap">
            <!-- TODO: 店家訊息 -->
            <text class="font-base">取餐時，請提供自取號碼。</text>
            <text class="font-base">付款後，依現場排序，完成取餐。</text>
        </div>
        <div v-if="isRetailPickUp && isCashPayment && customPaymentText"
            class="pickup-custom-payment-description">
            <div class="custom-payment-inner">
                <div>店家支付說明：</div>
                <div v-html="customPaymentText"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        geturlParameters() {
            return this.$route.params
        },
        getPayment() {
            return this.$store.state.cart.payment
        },
        isRetailPickUp() {
            return this.geturlParameters.method === 'retailPickUp'
        },
        isCashPayment() {
            return this.getPayment.paymentType === 'cash'
        },
        timeLabel() {
            return this.isRetailPickUp ? '取貨日期' : '取餐時間'
        },
        deliveryDate() {
            return this.getPayment.pickupDate
        },
        deliveryTime() {
            return this.getPayment.pickupTime
        },
        deliveryAddress() {
            return this.getPayment.address
        },
        deliveryPhone() {
            return this.getPayment.phone
        },
        customPaymentText() {
            return this.$store.getters['basic/customPaymentText']
        },
    }
}
</script>
<style lang="scss">
.pickup-custom-payment-description {
    width: 100%;
    margin-top: 12px;
    padding: 10px 14px;
    font-size: 14px;
    color: #FD5001;
    line-height: 1.5;
    border: 1px solid #FD5001;
    border-radius: 6px;
    display: flex;
    justify-content: center;
}

.custom-payment-inner {
    text-align: left;
}
</style>
